import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "no-scrollbar flex flex-1 items-center gap-2 overflow-x-auto px-4" }

import type { DashboardTableData, StatItem } from '@/types';
    import { Separator } from '@/components/ui/separator';
    import { computed, watch } from 'vue';
    import DashboardStat from '@/components/dashboard/DashboardStat.vue';
    import { useI18n } from 'vue-i18n';
    import type { Table } from '@tanstack/vue-table';
    import { AccountingDeadline, ReportDeadline, VatDeadline } from '@/components/icons';
    import { useDashboardStore } from '@/stores/dashboard';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardStats',
  props: {
    table: {},
    stats: {}
  },
  setup(__props: any) {

    const props = __props;

    const dashboardStore = useDashboardStore();
    const { t } = useI18n();

    const dashboardStats = computed<StatItem[]>(() => [
        {
            key: 'customers_assigned',
            value: props.stats.customers_assigned,
            icon: 'users',
            description: t('dashboards.employee.stats.customers_assigned'),
            isReset: true,
        },
        {
            key: 'customers_missing_vouchers',
            value: (props.stats.customers_missing_vouchers as number[]).length,
            icon: 'archive',
            description: t('dashboards.employee.stats.customers_missing_vouchers'),
            filter: {
                id: 'id',
                value: props.stats.customers_missing_vouchers,
            },
        },
        {
            key: 'customers_missing_report',
            value: (props.stats.customers_missing_report as number[]).length,
            icon: 'fileX',
            description: t('dashboards.employee.stats.customers_missing_report'),
            filter: {
                id: 'id',
                value: props.stats.customers_missing_report,
            },
        },
        {
            key: 'customers_missing_report_within_two_days',
            value: (props.stats.customers_missing_report_within_two_days as number[]).length,
            icon: 'hourglass',
            description: t('dashboards.employee.stats.customers_missing_report_within_two_days'),
            filter: {
                id: 'id',
                value: props.stats.customers_missing_report_within_two_days,
            },
        },
        {
            key: 'customers_over_report_deadline',
            value: (props.stats.customers_over_report_deadline as number[]).length,
            icon: 'clock',
            description: t('dashboards.employee.stats.cusomters_over_deadline'),
            filter: {
                id: 'id',
                value: props.stats.customers_over_report_deadline,
            },
        },
        {
            key: 'customers_missing_onboarding',
            value: (props.stats.customers_missing_onboarding as number[]).length,
            icon: 'listChecks',
            description: t('dashboards.employee.stats.customers_missing_onboarding'),
            filter: {
                id: 'id',
                value: props.stats.customers_missing_onboarding,
            },
        },
        {
            key: 'days_until_accounting_deadline',
            value: (props.stats.days_until_accounting_deadline as number[]).length,
            customIcon: AccountingDeadline,
            description: t('dashboards.employee.stats.days_until_accounting_deadline'),
            filter: {
                id: 'id',
                value: props.stats.days_until_accounting_deadline,
            },
        },
        {
            key: 'days_until_report_deadline',
            value: (props.stats.days_until_report_deadline as number[]).length,
            customIcon: ReportDeadline,
            description: t('dashboards.employee.stats.days_until_report_deadline'),
            filter: {
                id: 'id',
                value: props.stats.days_until_report_deadline,
            },
        },
        {
            key: 'days_until_vat_deadline',
            value: (props.stats.days_until_vat_deadline as number[]).length,
            customIcon: VatDeadline,
            description: t('dashboards.employee.stats.days_until_vat_deadline'),
            filter: {
                id: 'id',
                value: props.stats.days_until_vat_deadline,
            },
        },
    ]);

    watch(
        () => props.table,
        () => {
            console.log('mounted', dashboardStore.activeFilter);
            if (props.table && dashboardStore.activeFilterKey) {
                props.table?.setColumnFilters([dashboardStore.activeFilter]);
            }
        },
    );

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(Separator), {
      orientation: "vertical",
      class: "ml-4 h-2.5!"
    }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dashboardStats.value, (item) => {
        return (_openBlock(), _createBlock(DashboardStat, {
          table: _ctx.table,
          item: item
        }, null, 8, ["table", "item"]))
      }), 256))
    ])
  ], 64))
}
}

})